var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [_vm._m(0)]
        : _vm.lang == _vm.$config.LANG_ENG
        ? [_vm._m(1)]
        : [_vm._m(2)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("개인당좌예금")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [_vm._v(" 가계당좌 결제용 입출금이 자유로운 통장 ")])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("상품유형")]),
          _c("dd", [_vm._v("당좌예금")]),
          _c("dt", [_vm._v("상품개요")]),
          _c("dd", [_vm._v("가계당좌 결제용 입출금이 자유로운 통장")]),
          _c("dt", [_vm._v("가입대상")]),
          _c("dd", [_vm._v("18세 이상 성인")]),
          _c("dt", [_vm._v("계약 기간")]),
          _c("dd", [_vm._v("제한없음")]),
          _c("dt", [_vm._v("가입통화")]),
          _c("dd", [_vm._v("USD, KHR")]),
          _c("dt", [_vm._v("가입금액")]),
          _c("dd", [_vm._v("신규가입 시 최저 USD 1,000.00 이상")]),
          _c("dt", [_vm._v("금리 및 이율")]),
          _c("dd", [_vm._v("약정이율 연 0.00% (USD 및 KHR 공통적용)")]),
          _c("dt", [_vm._v("수수료")]),
          _c("dd", [_vm._v("해당무")]),
          _c("dt", [_vm._v("가입방법")]),
          _c("dd", [_vm._v("영업점가입")]),
          _c("dt", [_vm._v("가입시 필요서류")]),
          _c("dd", [_vm._v("ID 카드, 여권 등 실명확인증표")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [
          _c("h2", [_vm._v("Personal Checking Account")])
        ]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(
              " Saving with free deposit and withdrawal by using slip and check book. "
            )
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("Types")]),
          _c("dd", [_vm._v("Checking Account")]),
          _c("dt", [_vm._v("About the products")]),
          _c("dd", [
            _vm._v(
              "Saving with free deposit and withdrawal by using slip and check book."
            )
          ]),
          _c("dt", [_vm._v("Eligibilty")]),
          _c("dd", [_vm._v("Adults over 18 years old")]),
          _c("dt", [_vm._v("Contract Terms")]),
          _c("dd", [_vm._v("No restrictions")]),
          _c("dt", [_vm._v("Available currency")]),
          _c("dd", [_vm._v("USD, KHR")]),
          _c("dt", [_vm._v("Deposit amount")]),
          _c("dd", [
            _vm._v(
              "To open a new account, a minimum USD 1,000.00 deposit amount is required."
            )
          ]),
          _c("dt", [_vm._v("Rates")]),
          _c("dd", [
            _vm._v(
              "Agreed interest rate of 0.00% annually (for both USD and KHR)"
            )
          ]),
          _c("dt", [_vm._v("Fees")]),
          _c("dd", [_vm._v("N/A")]),
          _c("dt", [_vm._v("How to apply")]),
          _c("dd", [_vm._v("Apply at the branch")]),
          _c("dt", [_vm._v("Required documents for application")]),
          _c("dd", [_vm._v("ID card, passport, identity verification, etc.")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll" }, [
      _c("article", { staticClass: "content-header bg-type" }, [
        _c("div", { staticClass: "title" }, [_c("h2", [_vm._v("គណនីចរន្ដ")])]),
        _c("div", { staticClass: "description" }, [
          _c("p", [
            _vm._v(" គណនីដែលអាចសន្សំ និងដកប្រាក់ដោយប្រើប័ណ្ណរឺមូលប្បទានប័ត្រ ")
          ])
        ])
      ]),
      _c("article", { staticClass: "contents" }, [
        _c("dl", { staticClass: "dlist dlist-item--type5" }, [
          _c("dt", [_vm._v("ប្រភេទផលិតផល")]),
          _c("dd", [_vm._v("Checking Account")]),
          _c("dt", [_vm._v("មាតិកាផលិតផល")]),
          _c("dd", [
            _vm._v("គណនីដែលអាចសន្សំ និងដកប្រាក់ដោយប្រើប័ណ្ណរឺមូលប្បទានប័ត្រ")
          ]),
          _c("dt", [_vm._v("អតិថិជនគោលដៅ")]),
          _c("dd", [_vm._v("អ្នកដែលមានអាយុចាប់ពី១៨ឆ្នាំឡើងទៅ")]),
          _c("dt", [_vm._v("រយៈពេលកិច្ចសន្យា")]),
          _c("dd", [_vm._v("មិនមានកំនត់")]),
          _c("dt", [_vm._v("ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ")]),
          _c("dd", [_vm._v("USD, KHR")]),
          _c("dt", [_vm._v("ចំនួនទឹកប្រាក់ដែលស្នើសុំ")]),
          _c("dd", [_vm._v("ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD1,000.00")]),
          _c("dt", [_vm._v("អត្រាការប្រាក់")]),
          _c("dd", [
            _vm._v(
              "ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.00% (ប្រាក់រៀលនិងប្រាក់ដុល្លាគិតដូចគ្នា)"
            )
          ]),
          _c("dt", [_vm._v("កំរៃសេវា")]),
          _c("dd", [_vm._v("គ្មាន")]),
          _c("dt", [_vm._v("របៀបចុះឈ្មោះ")]),
          _c("dd", [_vm._v("ចុះឈ្មោះនៅសាខា")]),
          _c("dt", [_vm._v("តំរូវការឯកសារចុះឈ្មោះ")]),
          _c("dd", [_vm._v("អត្តសញ្ញាណប័ណ្ណ រឺ លិខិតឆ្លងដែន ។ល។")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }